import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@eo/shared';

import type { AlreadyLoggedDialogProps } from './types';

export function AlreadyLoggedDialog({ row, onLog, onClose }: AlreadyLoggedDialogProps) {
  return (
    <Dialog open onOpenChange={(next) => (next ? undefined : onClose())}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Already logged in ClickUp</DialogTitle>
          <DialogDescription>
            {`“${row.title}” is already covered by ‘${row.loggedAs?.title ?? ''}’ in ClickUp. Logging it again counts this time twice.`}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="ghost" onClick={onClose}>
            Cancel
          </Button>
          <Button
            onClick={() => {
              onClose();
              onLog();
            }}
          >
            Log it again
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
